<template>
    <article class="secondary-article">
        <figure>
            <div class="img">
                <img :src="getFirstActveImage(img)" alt="imagem" />
            </div>
            <figcaption>
                <article-header :category="category" :date="date" />
                <p
                    class="secondary-article-text"
                    v-html="text.substring(0, 150)"
                    v-if="text.length > 0"
                ></p>
                <span class="leia-mais">...Leia mais</span>
            </figcaption>
        </figure>
    </article>
</template>

<script>
import ArticleHeader from "./article-header";
import Images from "../../../../mixins/images.mixin";
export default {
    name: "secondary-articles",
    components: {
        ArticleHeader
    },
    mixins: [Images],
    props: {
        category: String,
        text: String,
        img: Array,
        date: String
    },
    computed: {
        imagem: function() {
            if (this.img) {
                let img = this.img.find(obj => {
                    return obj.ativo === 1;
                });
                return img.imagem;
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped lang="scss">
.secondary-article {
    max-width: 100%;
    figure {
        @apply flex flex-col mb-5;
        .img {
            @apply object-cover;
            min-width: 120px;
            // max-width: 150px;
            background-color: #fed843;
            border-radius: 10px;
        }

        .leia-mais {
            @apply text-black italic font-black;

            &:hover {
                @apply text-secondary;
            }
        }

        @media (min-width: 768px) {
            @apply flex-row mb-5;
            figcaption {
                .news-header {
                    @apply flex items-center justify-between py-2 px-0;
                    p {
                        @apply text-xs;
                        span {
                            @apply text-xs text-tertiary;
                        }
                    }
                }
            }
        }
        @media (min-width: 880px) {
            @apply w-full mb-0;
            .img {
                @apply mr-2;
                min-width: 170px;
                max-width: 180px;
                height: 170px;
                background-color: #fed843;
                border-radius: 10px;
            }
            figcaption {
                .news-header {
                    @apply flex items-center justify-between py-2 px-0;
                    p {
                        @apply text-xs;
                        span {
                            @apply text-xs text-tertiary;
                        }
                    }
                }
            }
        }
    }
    img {
        @apply w-full h-full rounded-md;
    }
    .secondary-article-text {
        @apply text-base;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}
.article-header {
    @apply flex flex-row justify-between items-center py-2 px-0;
    p {
        @apply text-xs;
        span {
            @apply text-tertiary text-xs;
        }
    }
}
</style>
